import {
  RemitSubmissionState,
  RemitUploadAction,
  useRemitUpload,
} from "contexts/RemitUploadContext";
import { ToastDetails, ToastState } from "models/ToastDetails";
import React, { useCallback, useEffect } from "react";

import { createOrUpdateToast } from "./AppToast";

const DEFAULT_TOAST_DURATION_MILLISECONDS = 60_000;

export const RemitUploadToastManager: React.FC = () => {
  const { state, dispatch } = useRemitUpload();

  const handleDismiss = useCallback((): void => {
    dispatch(RemitUploadAction.DismissToast);
  }, [dispatch]);

  useEffect(() => {
    if (!state.toastVisible) {
      return;
    }

    const toastId = state.toastId.toString();

    let toastDetails: ToastDetails;

    switch (state.submissionState) {
      case RemitSubmissionState.Submitting:
        toastDetails = {
          id: toastId,
          title: "Submitting notification...",
          message: "Your REMIT notification is being uploaded",
          state: ToastState.InProgress,
        };
        break;
      case RemitSubmissionState.Error:
        toastDetails = {
          id: toastId,
          title: "Submission failed",
          message: "Please try again later.",
          state: ToastState.Error,
        };
        break;
      case RemitSubmissionState.Complete:
        toastDetails = {
          id: toastId,
          title: "Submission complete",
          state: ToastState.Complete,
        };
        break;
      default:
        return;
    }

    createOrUpdateToast(
      toastDetails,
      DEFAULT_TOAST_DURATION_MILLISECONDS,
      handleDismiss,
      "remit-submission-toast"
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps -- updating on toastId causes an unnecessary render and it isn't changed elsewhere
  }, [state.submissionState, state.toastVisible]);

  return <></>;
};
